// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__fMqT3","notes":"Notes_notes__wTia_"};